export const common = {
  "title": "MOEA",
  "foot": "Galaxy Software Service Corp.",
  "login": {
    "announcement": "Notice",
    "userId": "User Account",
    "userPd": "User Password",
    "login": "Login",
    'required01': "Please Enter Your Account!",
    'required02': "Please Enter Your Password!",
  },
  "home": {
    "techName": "Project Use Technology",
    "refer": "Reference URL"
  },
  "button": {
    "query": "Query",
    "create": "Create",
    "update": "Update",
    "delete": "Delete",
    "save": "Save",
    "reset": "Reset",
    "cancel": "Cancel",
    "ok": "Ok",
    "view": "View"
  },
  "message": {
    "required01": "{} is Required",
    "required02": "Start Date is Required",
    "required03": "End Date is Required",
    "required04": "The expiration date cannot be earlier than the start date.",
    "required05": "{} is not a valid email address.",
    "delete01": "Do you want to delete?",
    "delete02": "Are you sure you want to delete this user?",
    "delete03": "Are you sure you want to delete this org?",
    "success01": "Success",
    "fail01": "Fail",
    "uploadLimit": "File uploaded must be less than "
  },
  "date": {
    "date01": "YYYY/MM/DD"
  }
}

